<template>
    <div v-on:click="handleClick" :class="{'category-box' : true, 'checked': isChecked(), 'clicked': isClicked()}">
        <img v-if="isChecked() && !isClicked()" :src="'/img/categories/' + data.icon + '_checked.png'"/>
        <img v-if="isClicked()" :src="'/img/categories/' + data.icon + '_click.png'" />
        <img v-if="!isChecked() && !isClicked()" :src="'/img/categories/' + data.icon + '.png'" />

        <span>{{ data.name.charAt(0).toUpperCase() + data.name.slice(1) }}</span>
    </div>
</template>

<script>

    import Router from '../../../routing';

    export default {
        name: "CategoryBox",
        props: ["data", "checkedValues", "value", "index"],
        mounted() {

        },
        data() {
            return {
                baseUrl: Router.getBaseUrl(),
                checked: false,
                clicked: false
            }
        },
        methods: {
            handleClick: function () {
                if(this.isClicked()) {
                    this.$emit('input', -1);
                }
                else {
                    this.$emit('input', this.index);
                }
            },
            isChecked: function () {
                for(let i = 0; i < this.data.subCategories.length; i++) {
                    if(this.checkedValues.indexOf(this.data.subCategories[i].id) > -1) {
                        return true;
                    }
                }

                return false;
            },
            isClicked: function () {
                return (this.index === this.value);
            }
        }
    }
</script>

<style scoped lang="scss">

</style>